import { LauncherElement } from '../../types/launcherElement';

export const detectReferencePoint = (element: LauncherElement) => {
  const position = element?.props?.class?.position;

  if (position === 'absolute') {
    const top = element?.props?.class?.top;
    const bottom = element?.props?.class?.bottom;
    const left = element?.props?.class?.left;
    const right = element?.props?.class?.right;

    if ((top !== undefined && bottom !== undefined) || (left && right))
      return null; // Exception: there is no way to define a reference point

    if (top !== undefined && left !== undefined) return 'topLeft';
    if (top !== undefined && right !== undefined) return 'topRight';
    if (bottom !== undefined && left !== undefined) return 'bottomLeft';
    if (bottom !== undefined && right !== undefined) return 'bottomRight';

    return 'topLeft';
  }

  return 'relative';
};
